// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-fade-enter-active[data-v-12746e8d],.component-fade-leave-active[data-v-12746e8d]{transition:opacity .3s ease}.component-fade-enter[data-v-12746e8d],.component-fade-leave-to[data-v-12746e8d]{opacity:0}", ""]);
// Exports
module.exports = exports;
